import React, { useState, useEffect } from "react";
import "../../../node_modules/photoswipe/dist/photoswipe.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import LazyImage from "./LazyImage";

const ScreenshotGalleryApp = () => {
    const [screenshots, setScreenshots] = useState([]);

    // Fetch screenshots from the REST API
    useEffect(() => {
        // Define an async function to fetch the screenshots
        const fetchScreenshots = async () => {
            try {
                // Fetch the screenshots from the server using the WordPress REST API
                const response = await fetch(`${ajax_object.siteAddress}/wp-json/est-collage/v1/screenshots`);

                // If the response is not OK, throw an error
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                // Parse the response body as JSON to get the screenshot data
                const data = await response.json();

                // Set the state with the screenshot data
                setScreenshots(data);
            } catch (error) {
                // Log any errors that occur during the fetch operation
                console.error("Error fetching screenshots:", error);
            }
        };

        // Call the fetchScreenshots function when the component mounts
        fetchScreenshots();
    }, []);

    return (
        <Gallery>
            {screenshots.map((screenshot) => (
                <Item
                    key={screenshot.ID}
                    original={screenshot.url}
                    thumbnail={screenshot.medium}
                    width="1080"
                    height="763">
                    {({ ref, open }) => (
                        <LazyImage key={screenshot.ID} ref={ref} onClick={open} src={screenshot.medium} />
                    )}
                </Item>
            ))}
        </Gallery>
    );
};

export default ScreenshotGalleryApp;
